import { Td, Tr } from '@components/core-ui/Table';
import { Switch } from '@components/core-ui/form-elements/Switch';
import TrashBin from '@components/icons/TrashBin.svg';

import { EditCellContent } from './styles/EditCellContent';
import { TProps } from './types/TProps';

export const InlineEditRow = ({ data, featureFlags, editId, onEditFeatureFlag, onRemoveFeatureFlag }: TProps) => {
  if (data.id !== editId) {
    return null;
  }
  if (!data.featureFlags) {
    data.featureFlags = {};
  }

  return (
    <Tr>
      <Td colSpan={100}>
        <EditCellContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <div className="feature-flags-head">Feature Flags</div>
              <div className="feature-flags-list">
                {Object.keys(data.featureFlags).map((flagName) => {
                  if (!data.featureFlags) {
                    return null;
                  }
                  const value = data.featureFlags[flagName];
                  return (
                    <div key={`${data.id}-${flagName}`} className="feature-flag">
                      <Switch
                        className="switch"
                        checked={!!value}
                        onChange={() => onEditFeatureFlag(data.id, flagName, !value)}
                      />
                      <div className="label">{flagName}</div>
                      <button
                        type="button"
                        onClick={async () => {
                          await onRemoveFeatureFlag(data.id, flagName);
                        }}
                      >
                        <TrashBin />
                      </button>
                    </div>
                  );
                })}

                {Object.keys(featureFlags)
                  .filter((f) => !Object.keys(data.featureFlags).includes(f))
                  .map((flagName) => {
                    if (!featureFlags) {
                      return null;
                    }
                    const value = featureFlags[flagName];
                    return (
                      <div
                        key={`${data.id}-${flagName}`}
                        className="feature-flag"
                        onClick={() => onEditFeatureFlag(data.id, flagName, !value)}
                      >
                        <Switch className="switch" checked={!!value} disabled={true} onChange={() => {}} />
                        <div className="label">{flagName}</div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </EditCellContent>
      </Td>
    </Tr>
  );
};
